export default "__VITE_ASSET__BOZAf1iP__"